import { searchFeaturesPFGQL } from '../../Module/graphQL/PathFinder/pathFinderGQL'
import { formatFeaturesToOverlays } from '../../Containers/BuilderMap/util'
import { convertArrayToHashMap } from '../../shared/libraries/dataSets'

/**
 * React hook to fetch data from the GraphQL endpoint.
 * This is the wrapper over `useFetch` hook
 * @param {Object} args
 * @param {*} args.defaultFetchArgs arguments, passed to `fetchFn` on hook initialization
 * @param {function} args.fetchFn Required. Function to fetch data from the remote endpoint.
 * Endpoint has to fetch data from GraphQL.
 * It has to return fetch-based promise.
 * When this function is called on hook initialization - it will receive `defaultFetchArgs` from the hook arguments
 * When `refetch` is called - this function will be called and will receive arguments from refetch
 * @param {function} mapResponse Function that maps response data before saving in state
 * @param {boolean} skipFetchOnInit Do not fetch data when hook is initialized. Defaults to false
 * @param {*} defaultData Value that is set to `data` before fetch response is received.
 * It is set to data when hook is initialized and when `refetch` is called. Defaults to nul
 *
 * @returns {UseFetchResponse}
 */
const useOverlaysFetch = ({ mode, countryCode, processOverlays = o => o }) => {
  /**
   * Load all features that are in current map's viewbox from the PF
   * @param {array} area Map's viewbox
   */
  const loadData = async ({ layer, area, includeAddressCount, after }) => {
    if (!countryCode || !area || !layer) return
    const response = await searchFeaturesPFGQL({
      layer,
      countryCode,
      includeAddressCount,
      area,
      after,
    })
    const { data: rawAreasData, errors } = await response.json()

    if (errors) throw errors[0]
    const options = {
      mode,
      isPostcode: layer === 'Postcodes',
      isIRIS: ['IRISBoundaries', 'BEStatisticalSectors'].includes(layer),
    }

    if (!rawAreasData || !rawAreasData.searchFeatures) return {}
    const formattedOverlays = formatFeaturesToOverlays(
      rawAreasData.searchFeatures.collection.features,
      options,
    )

    const processedOverlays = processOverlays(formattedOverlays)
    const hashMap = convertArrayToHashMap(processedOverlays, 'id')

    return {
      pageInfo: rawAreasData.searchFeatures.pageInfo,
      data: hashMap,
    }
  }

  return { loadData }
}
export default useOverlaysFetch



// WEBPACK FOOTER //
// ./src/Utils/Hooks/useOverlaysFetch.js